import { render } from "./TopLinkCard.vue?vue&type=template&id=68baaf86&scoped=true&ts=true"
import script from "./TopLinkCard.vue?vue&type=script&lang=ts"
export * from "./TopLinkCard.vue?vue&type=script&lang=ts"

import "./TopLinkCard.vue?vue&type=style&index=0&id=68baaf86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68baaf86"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg,QCardSection});
